import React from "react";
import { ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import { isLdsAdmin } from "../Forms/TieredTreeBuilder/treeLogic";
import { isUnboundRefusal } from "../Views/PortalAccess/portalAccessLogic";

/**
 * Shown under the menu from get-repository. Admins always get the Portal access link, so an admin whose own user ID
 * is not bound yet (empty menu) can still reach the screen that binds it.
 */
const SidebarAccessFallback = ({ repoError, userInfo, onOpenPortalAccess }) => (
  <>
    {isUnboundRefusal(repoError) && (
      <Typography variant="caption" color="error" display="block" sx={{ mx: 2, my: 1 }}>
        Your login is not linked to an LDS user yet. Ask an LDS admin to set the owner email for user ID{" "}
        {userInfo?.id ?? "(unknown)"}.
      </Typography>
    )}
    {isLdsAdmin(userInfo) && (
      <ListItem disablePadding className="sideMenuItem" onClick={onOpenPortalAccess}>
        <ListItemButton className="sideNavButton">
          <ListItemText primary="Portal access" className="sideMenuItem" />
        </ListItemButton>
      </ListItem>
    )}
  </>
);

export default SidebarAccessFallback;
